module.exports = __webpack_public_path__ + "static/media/intransit trip.8cbd07cc.svg";